const data = {
  id: "utilities",
  title: "Utilities: Power, Water, & Gas",
  intro: "Why is your power bill higher than your neighbor's in Tennessee? Huntsville Utilities answers to an unelected board, TVA sets the ceiling, and ratepayers absorb the rest. Every provider, every rate decision, every comparison — documented.",
  tabs: [
    {
      id: "overview",
      label: "Overview",
      visual: { type: "placeholder", title: "In-progress visual", description: "This section is being expanded now. The shell is in place so the page loads cleanly while content is rebuilt." },
      issues: [
        {
          id: "in_progress",
          label: "In Progress",
          title: "Utilities: Power, Water, & Gas is being rebuilt",
          summary: "This section is being expanded now using the approved module structure.",
          details: "The page shell, routing, and component system are in place. This module is visible so the site feels complete, but the full issue set and action tooling are still being populated.",
          decoder: {
            whatsHappening: "This module is being rebuilt into the new structure.",
            connections: "The old mixed page/data system is being replaced with a cleaner module-based architecture.",
            benefits: "The benefit is a more stable, maintainable site that is easier to expand and update.",
            impact: "Right now, the impact is limited because this section is still being populated.",
            actions: {
              intro: "This section is still being built out. Check back as more issue cards and action paths are added.",
              contacts: [],
              meetings: [],
              paths: [],
              actions: []
            }
          }
        }
      ],
      trail: []
    },
    {
      id: "power",
      label: "Power",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "water",
      label: "Water",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "gas",
      label: "Gas",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
